import '@babel/polyfill';
jQuery(function ($) {
    console.log('gens.jsが読みこまれた');
    $('body').addClass('jquery-add-class');
});
if (document.querySelector('.belief-swiper')) {
    const swiperBelief = new Swiper('.belief-swiper', {
        direction: 'horizontal',
        slidesPerView: 1,
        loop: false,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return `<span class="${className}">${index + 1}</span>`;
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            hideOnClick: true
        },
        speed: 1000
    });
}
const instagramParent = document.querySelector('#instagram-list');
imageMapResize();
const gnav = document.querySelector(`.p-gnav`);
const gnavBtn = document.querySelector(`#js-gnav-trg`);
gnavBtn.addEventListener('click', function () {
    if (gnav.classList.contains(`is-active`) == false) {
        window.addEventListener(`scroll`, function () {
            gnav.classList.remove('is-active');
            gnavBtn.classList.remove('is-active');
        });
    }
    else {
    }
});
